module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAkBAMAAAB/KNeuAAAAGFBMVEVHcEzb29vc3Nzc3Nzc3Nzb29vR0dHb29tt/WXhAAAAB3RSTlMAcf7UFn8L7PaXvQAAADZJREFUGNNjYEABgQgma5EAnB1erghjspmXIyScyxESLINSAomNrGZghVHCEClsUcIcOS4QAADVtibngeqPGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-angle-right@2x.png
// module id = c1H/
// module chunks = 1